@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.loader {
    width: 30px;
}

.resetPasswordDescriptionBreak {
    display: none;

    @media (min-width: 768px) {
        display: block;
    }
}

.resetPasswordWrapper {
    width: 100%;
    padding: 40px 16px;
    border-radius: 16px;
    border: 2px solid v.$gray-border-panel-color;
    background: v.$gradient-form-card;
    backdrop-filter: blur(1px);

    @media (min-width: 768px) {
        padding: 40px;
        width: 440px;
        margin: 0 auto;
    }
}

.resetPasswordTitle {
    @include t.text(36px, 48px, "bold");
    color: v.$white-color;
    margin-bottom: 16px;
}

.resetPasswordDescription {
    @include t.text(14px, 22px, "normal");
    color: v.$gray-light-color;
    margin: 8px 0 16px 0;
}

.errorMessage {
    text-align: center;
    margin-top: 4px;
    color: v.$error-color;
    @include t.text(12px, 20px, "medium");
}

.formButton {
    cursor: pointer;
    width: 100%;
    display: flex;
    height: 48px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: v.$green-color;
    @include t.text(16px, 26px, "semi-bold");
    color: v.$white-color;

    &:disabled {
        cursor: not-allowed;
    }
}

.formDescriptionLink {
    display: flex;
    justify-content: center;
    gap: 4px;
    margin: 16px auto;
    color: v.$gray-light-color;
    @include t.text(14px, 22px, "normal");

    span {
        cursor: pointer;
        text-decoration: underline;
    }
}

/* Chinese Brothers */

.resetPasswordWrapperChineseBrothers {
  border: 1px solid v.$chinese-brothers-border-color;
  background: v.$chinese-brothers-card-bg;
}

.formButtonChineseBrothers {
  background: v.$white-color;
  color: v.$navy-dark-color-2;
}